/**
 * Input Schema of MotoristaTransbordo
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

/* TODO: review generated schema */
export class InputMotoristaTransbordoSchema extends Schema {
  collectionMotorista = new MotoristaCollection().noPagination()

  readonly name = 'InputMotoristaTransbordo'

  readonly fieldSet: FieldSet<MotoristaTransbordo> = {
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    podeReceber: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    podeEntregar: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
